export const getOperationNameForQuery = (queryObject) => queryObject?.definitions[0].name.value;
